{
  "enum": {
    "J5SchemaV1EntityPart": {
      "DATA": "Data",
      "DERIVED": "Derived",
      "EVENT": "Event",
      "KEYS": "Keys",
      "REFERENCES": "References",
      "STATE": "State",
      "STATUS": "Status",
      "SUMMARY": "Summary",
      "UNSPECIFIED": "Unspecified"
    },
    "J5SchemaV1FloatFieldFormat": {
      "FLOAT32": "Float32",
      "FLOAT64": "Float64",
      "UNSPECIFIED": "Unspecified"
    },
    "J5SchemaV1HttpMethod": {
      "DELETE": "DELETE",
      "GET": "GET",
      "PATCH": "PATCH",
      "POST": "POST",
      "PUT": "PUT",
      "UNSPECIFIED": "Unspecified"
    },
    "J5SchemaV1IntegerFieldFormat": {
      "INT32": "Int32",
      "INT64": "Int64",
      "UINT32": "Uint32",
      "UINT64": "Uint64",
      "UNSPECIFIED": "Unspecified"
    },
    "J5SchemaV1StateQueryPart": {
      "GET": "Get",
      "LIST": "List",
      "LIST_EVENTS": "List Events",
      "UNSPECIFIED": "Unspecified"
    }
  },
  "oneOf": {
    "J5SchemaV1Field": {
      "any": "Any",
      "array": "Array",
      "bool": "Bool",
      "bytes": "Bytes",
      "date": "Date",
      "decimal": "Decimal",
      "enum": "Enum",
      "float": "Float",
      "integer": "Integer",
      "key": "Key",
      "map": "Map",
      "object": "Object",
      "oneof": "Oneof",
      "polymorph": "Polymorph",
      "string": "String",
      "timestamp": "Timestamp"
    },
    "J5SchemaV1KeyFieldDeprecatedEntityKey": {
      "foreignKey": "Foreign Key",
      "primaryKey": "Primary Key"
    },
    "J5SchemaV1KeyFormat": {
      "custom": "Custom",
      "id62": "ID62",
      "informal": "Informal",
      "named": "Named",
      "uuid": "UUID"
    },
    "J5SchemaV1MethodType": {
      "stateQuery": "State Query"
    },
    "J5SchemaV1RootSchema": {
      "enum": "Enum",
      "object": "Object",
      "oneof": "One Of",
      "polymorph": "Polymorph"
    }
  }
}